import {createApi} from '../helpers'
export const createActions = createApi(
  process.browser ? '/api' : 'http://localhost:8080/api'
)
